import { UserSettings, userSettingsQuery } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createResourceQuery } from '@funtech-int/rival';
import { useResources } from '@funtech-int/rival-react';

import { GraphqlClient } from '@/shared/lib/graphqlClient';
import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';
import { InMemoryCache } from '@/shared/lib/inMemoryCache';
import { useInMemoryCache } from '@/shared/hooks/useInMemoryCache';

import { getUserSettingsKey } from '../lib/userSettings';

interface UserSettingsContext {
    client: GraphqlClient;
    inMemoryCache: InMemoryCache;
}

const userSettingsResourceQuery = createResourceQuery<UserSettingsContext, UserSettings>({
    key() {
        return [userSettingsQuery.name].join(':');
    },
    async fetch(ctx) {
        const { data } = await ctx.client.fetch({
            operation: userSettingsQuery,
            variables: {},
        });

        if (!data) {
            throw new Error('User settings not found');
        }

        ctx.inMemoryCache.set(
            getUserSettingsKey('preferredLanguage'),
            data.preferredWatchingLanguage?.code ?? null
        );

        return data;
    },
    toJSON(data) {
        return data;
    },
    hydrate(data: any) {
        return userSettingsQuery.hydrate(data) as any;
    },
});

export function useUserSettingsQuery() {
    const client = useGraphqlClient();
    const inMemoryCache = useInMemoryCache();

    const [settings] = useResources(
        userSettingsResourceQuery(
            {
                client,
                inMemoryCache,
            },
            { lifetime: 0 }
        )
    );

    return { settings };
}
